import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  challenges: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  loadChallenges ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']
    return HTTP
      .setInstance(sitekey)
      .challenge.getAll()
      .then((challenges) => {
        dispatch('challenges/resetChallenges', null, { root: true })
        commit('ADD_CHALLENGE_ITEMS', { items: challenges })
        return challenges
      })
  },
  resetChallenges ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_CHALLENGE_ITEMS')
      resolve()
    })
  },

  addChallenge ({ commit, rootGetters }, { challenge }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .challenge.create(challenge)
      .then((challenge) => {
        commit('ADD_CHALLENGE_ITEM', { item: challenge })
        return challenge
      })
  },

  updateChallenge ({ commit, rootGetters }, { challenge }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .challenge.update(challenge)
      .then((challenge) => {
        commit('UPDATE_CHALLENGE_ITEM', { item: challenge })
        return challenge
      })
  },

  removeChallenge ({ commit, rootGetters }, { challenge }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .challenge.delete(challenge)
      .then((challenges) => {
        commit('REMOVE_CHALLENGE_ITEM', { item: challenge })
      })
  }
}

// mutations
const mutations = {
  ADD_CHALLENGE_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_CHALLENGE_ITEMS: (state) => {
    state.items = []
  },

  ADD_CHALLENGE_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_CHALLENGE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_CHALLENGE_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/challenges.js